import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const notThis = ['This is not a random collection of techniques copied from YouTube.', 'This is not a theory manual you need to rewrite before it works in a real class.', 'This is not content designed for a different type of instructor that you have to completely adapt.'];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-navy-deep text-white relative overflow-hidden" data-id="element-262" data-mp="z2foehqopiuu">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gold/60" data-id="element-263" data-mp="u33526z0utx0" />
      <div className="max-w-4xl mx-auto text-center" data-id="element-264" data-mp="182b51230e629">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-265" data-mp="17zq187j5hg1v">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-white/10 border border-gold/40 mb-5" data-id="element-266" data-mp="2jg6najp7muxp">
            <span className="text-2xl" aria-hidden="true" data-id="element-267" data-mp="2ffctxat00nxf">
              🏆
            </span>
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4" data-id="element-268" data-mp="2bxtin9v1zw4n">
            The most complete Brazilian Jiu-Jitsu teaching library for
            instructors worldwide
          </h2>
          <h3 className="text-xl font-bold text-gold-light mb-3" data-id="element-269" data-mp="2kuaqo484fdw6">
            Brazilian Jiu-Jitsu Instructor Ready — A Complete 6-in-1 Teaching
            System
          </h3>
          <p className="text-base md:text-lg text-white/80 mb-10" data-id="element-270" data-mp="1t6si4heabsiz">
            100 ready-to-teach lessons · 5 Strategic Bonuses · Everything ready
            to use from today
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-271" data-mp="224kzrs7hbc9j">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-3 bg-white/5 p-6 rounded-2xl border border-white/15" data-id="element-272" data-mp="26xnva5vtgvsd">
            {notThis.map(item => <div key={item} className="flex items-start gap-3" data-id="element-273" data-mp="2hqpebsouj29m">
                <XIcon className="text-warmgray shrink-0 mt-1" size={18} data-id="element-274" data-mp="2how463f0xzwv" />
                <p className="text-white/70 text-sm" data-id="element-275" data-mp="2crvwxp6fur46">{item}</p>
              </div>)}
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-cream-card p-6 rounded-2xl border border-gold shadow-lg" data-id="element-276" data-mp="2qldgvb31e5uq">
            <div className="flex items-start gap-3" data-id="element-277" data-mp="1tubizd57pcyc">
              <CheckIcon className="text-forest shrink-0 mt-1" size={20} data-id="element-278" data-mp="1tvmnjf6heoqi" />
              <p className="text-ink font-medium text-base leading-relaxed" data-id="element-279" data-mp="27ucjuslh8kdt">
                This is a complete professional 6-in-1 teaching system — so you
                walk into every class fully prepared, confident and ready to
                deliver a session your students will actually feel.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}